module.exports = __webpack_public_path__ + "img/code.ffae9450.png";